/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponsePhaseDto } from '../../models/response-phase-dto';

export interface PhasesControllerFindById$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Unique phase identifier
 */
  phaseId: string;
}

export function phasesControllerFindById(http: HttpClient, rootUrl: string, params: PhasesControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponsePhaseDto>> {
  const rb = new RequestBuilder(rootUrl, phasesControllerFindById.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('phaseId', params.phaseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponsePhaseDto>;
    })
  );
}

phasesControllerFindById.PATH = '/thalea-pathways/phases/id/{tenant}/{phaseId}';
